import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@shared/components/ui/shadcn/accordion';
import { Alert, AlertTitle, AlertDescription } from '@shared/components/ui/shadcn/alert';
import { RadioGroup, RadioGroupItem } from '@shared/components/ui/shadcn/radio-group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';
import { Label } from '@shared/components/ui/label';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '@shared/hooks/usePermissions';

export const RejectedAccordion = () => {
  const { t } = useTranslation('generalModule');
  const { canAccess } = usePermissions();

  // 🎯 Verificar permiso de edición
  const canEdit = canAccess(['tenant', 'tenant_3pl'], ['configuration.edit']);

  return (
    <>
      <h2 className="text-2xl font-semibold mb-4">{t('rejected.title')}</h2>
      <Accordion type="multiple" defaultValue={['max-qty']} className="w-full">
        <AccordionItem value="max-qty">
          <AccordionTrigger>{t('rejected.max_qty')}</AccordionTrigger>
          <AccordionContent className="space-y-4">
            <Alert variant="default">
              <div className="flex items-start gap-3">
                <FontAwesomeIcon icon={faCircleInfo} className="text-muted-foreground mt-1 w-4 h-4" />
                <div>
                  <AlertTitle>{t('rejected.max_qty_alert_title')}</AlertTitle>
                  <AlertDescription>{t('rejected.max_qty_alert_description')}</AlertDescription>
                </div>
              </div>
            </Alert>

            <RadioGroup defaultValue="manual" className="space-y-2" disabled={!canEdit}>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="manual" id="manual" />
                <Label htmlFor="manual">{t('rejected.radio.manual')}</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="auto" id="auto" />
                <Label htmlFor="auto">{t('rejected.radio.auto')}</Label>
              </div>
            </RadioGroup>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  );
};
